import { put } from 'redux-saga/effects';

function* bootup() {
  yield put({
    type: 'SET_INITIAL_VIEWPORT',
  });
}
const sagas = {
  bootup,
};

export { sagas };
